/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ReplyAllIcon = /*#__PURE__*/ createSvgIcon(
  'ReplyAllIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.56 1.648V6.4h2.24c1.707 0 3.414.704 4.686 2.217 1.27 1.51 2.074 3.784 2.074 6.883v1.643l-.915-1.364c-.695-1.036-1.745-1.57-2.752-1.844-1.009-.274-1.93-.275-2.313-.275h-3.02v4.692L3.402 10l7.158-8.352zM4.72 10L9.56 15.65V12.66h4.024c.4 0 1.43 0 2.57.31.772.21 1.613.566 2.348 1.175-.197-2.213-.877-3.81-1.78-4.884-1.076-1.28-2.5-1.86-3.922-1.86H9.56V4.35l-4.841 5.65z"
            fill="currentColor"
          />
          <path
            d="M6.58 15.71l-4.74-5.68 5.72-6.86V1.62l-7 8.41 7 8.4v-1.54l-.98-1.18z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  true
);

export default ReplyAllIcon;
